import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";

// All returns processing routes are fullscreen for warehouse workers on tablets/iPads
const FULLSCREEN_ROUTES: string[] = [
  "/returns/processing",
  "/returns/processing/:returnLabel",
  "/returns/processing/:returnLabel/inspect/:sessionItemId",
];

function isFullscreenRoute(url: string): boolean {
  return FULLSCREEN_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId${route}`, url),
  );
}

export const returnsProcessingRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Returns Processing" },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={isFullscreenRoute}
            hideNavbar={isFullscreenRoute}
            hidePadding={isFullscreenRoute}
          />
        ),
      };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ReturnLookupPage } = await import(
            "@redotech/redo-merchant-returns-processing-app/lookup-page"
          );
          return { Component: ReturnLookupPage };
        },
      },
      {
        path: ":returnLabel",
        async lazy() {
          const { ProcessingLayout } = await import(
            "@redotech/redo-merchant-returns-processing-app/processing-layout"
          );
          return { Component: ProcessingLayout };
        },
        children: [
          {
            index: true,
            handle: { breadcrumb: "Process Return" },
            async lazy() {
              const { ReturnProcessingPage } = await import(
                "@redotech/redo-merchant-returns-processing-app/processing-page"
              );
              return { Component: ReturnProcessingPage };
            },
          },
          {
            path: "inspect/:sessionItemId",
            handle: { breadcrumb: "Inspect Item" },
            async lazy() {
              const { ItemInspectionPage } = await import(
                "@redotech/redo-merchant-returns-processing-app/inspection-page"
              );
              return { Component: ItemInspectionPage };
            },
          },
        ],
      },
    ],
  },
];
